var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _rect, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogoNine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 52,
    viewBox: "0 0 146 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0795 33.3002H66.6792V37.5517H53.6348V15.0059H58.0795V33.3002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1167 26.0211C84.1167 26.4506 84.3958 26.8049 84.9541 27.084C85.5339 27.3417 86.2317 27.5779 87.0477 27.7926C87.8636 27.9858 88.6796 28.2435 89.4955 28.5656C90.3115 28.8662 90.9986 29.3815 91.5568 30.1116C92.1366 30.8416 92.4265 31.7542 92.4265 32.8493C92.4265 34.5027 91.8038 35.7803 90.5584 36.6821C89.3345 37.5624 87.7992 38.0026 85.9526 38.0026C82.6459 38.0026 80.3913 36.725 79.1888 34.1698L82.7962 32.1407C83.2686 33.5364 84.3207 34.2342 85.9526 34.2342C87.4342 34.2342 88.175 33.7726 88.175 32.8493C88.175 32.4198 87.8851 32.0763 87.3053 31.8186C86.7471 31.5395 86.0599 31.2926 85.244 31.0778C84.4281 30.8631 83.6121 30.5947 82.7962 30.2726C81.9802 29.9505 81.2824 29.4459 80.7026 28.7588C80.1443 28.0502 79.8652 27.1699 79.8652 26.1177C79.8652 24.5288 80.445 23.2834 81.6045 22.3816C82.7854 21.4583 84.2455 20.9966 85.9848 20.9966C87.2946 20.9966 88.4863 21.2972 89.5599 21.8984C90.6335 22.4782 91.4817 23.3156 92.1044 24.4107L88.5615 26.3432C88.0461 25.2481 87.1872 24.7006 85.9848 24.7006C85.448 24.7006 84.9971 24.8187 84.632 25.0549C84.2885 25.2911 84.1167 25.6131 84.1167 26.0211Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.449 25.4414H101.809V32.1407C101.809 32.699 101.949 33.107 102.228 33.3646C102.507 33.6223 102.915 33.7726 103.452 33.8155C103.989 33.837 104.654 33.8263 105.449 33.7833V37.5517C102.593 37.8738 100.575 37.6054 99.3935 36.7465C98.234 35.8876 97.6543 34.3523 97.6543 32.1407V25.4414H94.8522V21.4475H97.6543V18.1945L101.809 16.9384V21.4475H105.449V25.4414Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.996 31.2067C113.554 33.2251 115.068 34.2342 117.537 34.2342C119.126 34.2342 120.329 33.6974 121.145 32.6238L124.494 34.5563C122.905 36.8539 120.565 38.0026 117.473 38.0026C114.81 38.0026 112.674 37.1974 111.064 35.587C109.453 33.9766 108.648 31.9475 108.648 29.4996C108.648 27.0733 109.442 25.0549 111.031 23.4444C112.62 21.8126 114.66 20.9966 117.151 20.9966C119.513 20.9966 121.456 21.8126 122.981 23.4444C124.527 25.0763 125.3 27.0947 125.3 29.4996C125.3 30.0364 125.246 30.6054 125.139 31.2067H112.996ZM112.932 27.9858H121.145C120.909 26.8907 120.415 26.0748 119.663 25.538C118.933 25.0012 118.096 24.7328 117.151 24.7328C116.034 24.7328 115.111 25.0227 114.381 25.6024C113.651 26.1607 113.168 26.9552 112.932 27.9858Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.195 31.2067C133.754 33.2251 135.268 34.2342 137.737 34.2342C139.326 34.2342 140.528 33.6974 141.344 32.6238L144.694 34.5563C143.105 36.8539 140.764 38.0026 137.672 38.0026C135.01 38.0026 132.873 37.1974 131.263 35.587C129.653 33.9766 128.847 31.9475 128.847 29.4996C128.847 27.0733 129.642 25.0549 131.231 23.4444C132.82 21.8126 134.86 20.9966 137.35 20.9966C139.712 20.9966 141.656 21.8126 143.18 23.4444C144.726 25.0763 145.499 27.0947 145.499 29.4996C145.499 30.0364 145.445 30.6054 145.338 31.2067H133.195ZM133.131 27.9858H141.344C141.108 26.8907 140.614 26.0748 139.863 25.538C139.133 25.0012 138.295 24.7328 137.35 24.7328C136.234 24.7328 135.31 25.0227 134.58 25.6024C133.85 26.1607 133.367 26.9552 133.131 27.9858Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2307,
    cy: 16.9289,
    r: 2.70334,
    fill: "#C10037"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.2151,
    cy: 16.9289,
    r: 2.70334,
    fill: "#C10037",
    fillOpacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2014,
    cy: 16.9289,
    r: 2.70334,
    fill: "#C10037",
    fillOpacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71.1191,
    y: 21.6611,
    width: 4.22228,
    height: 16.0031,
    fill: "#C10037"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3825 41.4047C21.2882 44.1792 27.2845 44.1792 32.1901 41.4047C32.6548 41.1419 33.1171 40.875 33.577 40.604C38.4326 37.7428 41.4308 32.5499 41.4808 26.9143C41.4856 26.3804 41.4856 25.8465 41.4808 25.3125C41.4307 19.677 38.4327 14.4842 33.5772 11.623C33.1172 11.352 32.6549 11.085 32.1901 10.8222C27.2845 8.04769 21.2882 8.0477 16.3825 10.8222C15.9178 11.085 15.4555 11.3519 14.9956 11.6229C10.14 14.484 7.14186 19.677 7.0918 25.3126C7.08706 25.8465 7.08706 26.3804 7.0918 26.9143C7.14188 32.5498 10.1399 37.7427 14.9954 40.6038C15.4554 40.8749 15.9178 41.1419 16.3825 41.4047Z",
    fill: "#C10037"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1855_17308",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 35,
    height: 36
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3825 41.4047C21.2882 44.1792 27.2845 44.1792 32.1901 41.4047C32.6548 41.1419 33.1171 40.875 33.577 40.604C38.4326 37.7428 41.4308 32.5499 41.4808 26.9143C41.4856 26.3804 41.4856 25.8465 41.4808 25.3125C41.4307 19.677 38.4327 14.4842 33.5772 11.623C33.1172 11.352 32.6549 11.085 32.1901 10.8222C27.2845 8.04769 21.2882 8.0477 16.3825 10.8222C15.9178 11.085 15.4555 11.3519 14.9956 11.6229C10.14 14.484 7.14186 19.677 7.0918 25.3126C7.08706 25.8465 7.08706 26.3804 7.0918 26.9143C7.14188 32.5498 10.1399 37.7427 14.9954 40.6038C15.4554 40.8749 15.9178 41.1419 16.3825 41.4047Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1855_17308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7193 48.2441L13.4921 30.8512L27.6224 18.02L30.0367 19.525L32.1918 16.9053L33.1701 16.9831L43.8074 37.4996L23.7193 48.2441Z",
    fill: "#233B4F",
    fillOpacity: 0.29
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6801 30.7856L14.4749 31.2242C14.0457 31.3804 13.5694 31.1583 13.4132 30.7291L12.9552 29.4708C12.799 29.0416 13.0211 28.5653 13.4503 28.4091L14.6554 27.9704C14.8706 27.8921 15.108 28.0028 15.1863 28.218L15.9276 30.2547C16.0059 30.4699 15.8952 30.7073 15.6801 30.7856Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4882 35.1329L19.9527 35.3278C19.3089 35.5621 18.5945 35.229 18.3602 34.5851L17.128 31.1998C17.0497 30.9846 17.1604 30.7472 17.3755 30.6689L19.4678 29.9074C19.6829 29.8291 19.9204 29.9398 19.9987 30.1549L21.2308 33.5403C21.4652 34.1841 21.1321 34.8985 20.4882 35.1329Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2853 30.1272L16.9028 31.7223C16.2589 31.9566 15.5446 31.6235 15.3102 30.9797L14.2472 28.0592C14.0129 27.4154 14.346 26.701 14.9899 26.4666L19.3724 24.8715C19.5876 24.7932 19.825 24.9039 19.9033 25.1191L21.5329 29.5963C21.6112 29.8116 21.5005 30.0489 21.2853 30.1272Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0264 27.7759C14.9483 27.5612 15.0593 27.3232 15.274 27.2451L19.2673 25.7917L20.6136 29.4905L16.6203 30.9439C16.4055 31.0221 16.1675 30.9111 16.0894 30.6964L15.0264 27.7759Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0389 31.7257C30.8352 31.7999 30.6145 31.8286 30.3902 31.8051C30.38 31.8041 30.37 31.8026 30.36 31.8011L21.0716 30.1454C20.9261 30.1196 20.8057 30.0179 20.7552 29.8793L19.1257 25.4021C19.0751 25.2633 19.1021 25.108 19.1969 24.9948L25.248 17.756C25.6208 17.3707 26.1247 17.2179 26.6176 17.3234C27.1109 17.4287 27.5085 17.7748 27.6811 18.2491L31.9071 29.8598C32.0797 30.3341 31.9976 30.8547 31.6874 31.2526C31.5156 31.4724 31.2904 31.6342 31.0389 31.7257Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4746,
    y: 19.8584,
    width: 4.58783,
    height: 1.51491,
    rx: 0.757457,
    transform: "rotate(-50 29.4746 19.8584)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.668,
    y: 22.9316,
    width: 4.58783,
    height: 1.51491,
    rx: 0.757457,
    transform: "rotate(-20 30.668 22.9316)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5098,
    y: 25.9854,
    width: 4.58783,
    height: 1.51491,
    rx: 0.757457,
    transform: "rotate(10 32.5098 25.9854)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogoNine);
export default __webpack_public_path__ + "static/media/footer-logo-nine.3ea4311d576ff51e84857446355b0503.svg";
export { ForwardRef as ReactComponent };